import React from "react";
import Styles from "./styles.module.scss";
import {useDispatch} from "react-redux";
import {sendIdoFormFailure} from "../../../store/main/action";

const CustomFormInput = (props) => {
    const {
        title,
        type = "text",
        placeholder = "",
        className = "",
        err,
        value = "",
        onChangeAction,
        formErr,
        name,
        ...rest
    } = props;

    const dispatch = useDispatch();

    const handleChange = (e) => {
        // если обработчик не передали — просто ничего не делаем
        if (!onChangeAction) return;
        onChangeAction(e.target.value);
    };

    const isTextarea = type === "textarea";

    return (
        <div className={`${Styles.inputWrap} ${err ? Styles.inputWrapWithErr : null}`}>
            {title && <div className={Styles.inputTitle}>{title}</div>}

            {isTextarea ? (
                <textarea
                    {...rest}
                    placeholder={placeholder}
                    className={`${Styles.textarea} ${className}`.trim()}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={(event)=>{
                        if (formErr[name]){
                            delete formErr[name];
                            dispatch(sendIdoFormFailure(formErr));
                        }
                    }}
                />
            ) : (
                <input
                    {...rest}
                    type={type}
                    placeholder={placeholder}
                    className={`${Styles.input} ${className}`.trim()}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={(event)=>{
                        if (formErr[name]){
                            delete formErr[name];
                            dispatch(sendIdoFormFailure(formErr));
                        }
                    }}
                />
            )}

            {err && <div className={Styles.inputErr}>{err}</div>}
        </div>
    );
};

export default CustomFormInput;